import { IAction } from '~/shared/store/types'
import { IUserAccountStatus, IUserStatus } from '~/shared/types/userTypes'

import {
  SET_STATUS,
  SET_USER_ACCOUNT_STATUS,
  SET_UTM_TAGS,
  SET_UUID,
  UPDATE_USER_CONFIG,
} from '../actionTypes'

export function setUUIDAction(uuid: string): IAction<string> {
  return {
    type: SET_UUID,
    payload: uuid,
  }
}

export function setUserStatusAction(
  userStatus: IUserStatus,
): IAction<IUserStatus> {
  return {
    type: SET_STATUS,
    payload: userStatus,
  }
}

export function updateUserConfigAction(
  value: Record<string, string | number>,
): IAction<Record<string, string | number>> {
  return {
    type: UPDATE_USER_CONFIG,
    payload: value,
  }
}

export function setUtmTags(
  payload: Record<string, string>,
): IAction<Record<string, string>> {
  return {
    type: SET_UTM_TAGS,
    payload,
  }
}

export const setUserAccountStatusAction = (
  accountStatus: IUserAccountStatus,
): IAction<IUserAccountStatus> => ({
  type: SET_USER_ACCOUNT_STATUS,
  payload: accountStatus,
})
